import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

// Client/runtime (Vite) environment variables
// Only variables prefixed with VITE_ are allowed on the client.
export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_CLERK_PUBLISHABLE_KEY: z.string().min(1),
    VITE_CLERK_FRONTEND_API_URL: z.url().optional(),
    VITE_CONVEX_URL: z.url(),
    // Optional: Google Maps JS API key for Places Autocomplete in client
    VITE_GOOGLE_MAPS_API_KEY: z.string().optional(),
    // Sentry Error Tracking (Frontend)
    VITE_SENTRY_DSN: z.string().url().optional(),
    VITE_SENTRY_ENVIRONMENT: z.string().optional(),
    VITE_SENTRY_RELEASE: z.string().optional(),
    // PostHog Analytics (Frontend)
    VITE_POSTHOG_API_KEY: z.string().optional(),
    VITE_POSTHOG_HOST: z.string().url().optional(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
  onValidationError: (issues) => {
    // Fail fast with helpful message during dev and build

    console.error('Invalid environment variables:', issues);
    throw new Error('Invalid environment variables. Check your .env files.');
  },
  onInvalidAccess: (variable) => {
    throw new Error(`Attempted to access a server-only environment variable on the client: ${variable}`);
  },
});

export type ClientEnv = typeof env;
